"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTheme = exports.ThemeProvider = exports.ThemeContext = exports.createTheme = exports.defaultTheme = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var breakpoints_1 = require("./breakpoints");
var palette_1 = require("./palette");
var typography_1 = require("./typography");
var transitions_1 = require("./transitions");
var accordions_1 = require("./components/accordions");
var deepmerge_1 = __importDefault(require("deepmerge"));
var shadows_1 = require("./shadows");
var components_1 = require("./components");
exports.defaultTheme = {
    breakpoints: breakpoints_1.defaultBreakpoints,
    palette: palette_1.defaultPalette,
    shadows: shadows_1.defaultShadows,
    typography: typography_1.defaultTypography,
    transitions: (0, transitions_1.createTransitions)({}),
    components: {
        accordions: accordions_1.defaultThemeAccordions,
    }
};
function createTheme(options) {
    if (options === void 0) { options = {}; }
    var _a = options.breakpoints, breakpointsInput = _a === void 0 ? {} : _a, 
    // mixins: mixinsInput = {},
    // spacing: spacingInput,
    _b = options.palette, 
    // mixins: mixinsInput = {},
    // spacing: spacingInput,
    paletteInput = _b === void 0 ? {} : _b, _c = options.transitions, transitionsInput = _c === void 0 ? {} : _c, _d = options.typography, typographyInput = _d === void 0 ? {} : _d, _e = options.components, componentsInput = _e === void 0 ? {} : _e;
    return (0, deepmerge_1.default)(exports.defaultTheme, {
        breakpoints: breakpointsInput,
        palettee: (0, palette_1.createPalette)(paletteInput),
        typography: (0, typography_1.createTypography)(typographyInput),
        transitions: (0, transitions_1.createTransitions)(transitionsInput),
        components: (0, components_1.composeComponents)(componentsInput),
    });
}
exports.createTheme = createTheme;
exports.ThemeContext = (0, react_1.createContext)(exports.defaultTheme);
var ThemeProvider = function (_a) {
    var children = _a.children, theme = _a.theme;
    return (0, jsx_runtime_1.jsx)(exports.ThemeContext.Provider, __assign({ value: theme }, { children: children }));
};
exports.ThemeProvider = ThemeProvider;
var useTheme = function () {
    var context = (0, react_1.useContext)(exports.ThemeContext);
    if (!context)
        return exports.defaultTheme;
    return context;
};
exports.useTheme = useTheme;
//# sourceMappingURL=context.js.map